export default __webpack_public_path__ + "static/media/81.0e916820.jpg";